"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_VENUE_TIMEZONE = exports.REGIONAL_VENUE_CLOSING_HOUR = exports.VENUE_CLOSING_CRON_INTERVAL_MINUTES = exports.VENUE_CLOSING_WARNING_MINUTES = void 0;
exports.resolveVenueTimezone = resolveVenueTimezone;
exports.getEffectiveOpeningHours = getEffectiveOpeningHours;
exports.hasDefinedClosingHours = hasDefinedClosingHours;
exports.planVenueClosingTimers = planVenueClosingTimers;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const resolve_venue_opening_hours_1 = require("./resolve-venue-opening-hours");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
exports.VENUE_CLOSING_WARNING_MINUTES = 5;
/** How often the server scans venues and schedules in-memory timers. */
exports.VENUE_CLOSING_CRON_INTERVAL_MINUTES = 30;
exports.REGIONAL_VENUE_CLOSING_HOUR = 4;
exports.DEFAULT_VENUE_TIMEZONE = 'America/Chicago';
function resolveVenueTimezone(venue) {
  var _venue$openingHoursTi;
  const tz = (_venue$openingHoursTi = venue.openingHoursTimezone) === null || _venue$openingHoursTi === void 0 ? void 0 : _venue$openingHoursTi.trim();
  return tz && tz.length > 0 ? tz : exports.DEFAULT_VENUE_TIMEZONE;
}
function getEffectiveOpeningHours(venue) {
  return (0, resolve_venue_opening_hours_1.resolveVenueOpeningHours)(venue).openingHours;
}
/** True when at least one period has an explicit close time (not 24h-only). */
function hasDefinedClosingHours(hours) {
  var _hours$periods;
  if (!(hours !== null && hours !== void 0 && (_hours$periods = hours.periods) !== null && _hours$periods !== void 0 && _hours$periods.length)) {
    return false;
  }
  return hours.periods.some(period => period.close != null);
}
function closeInstantForAnchor(anchor, period) {
  if (!period.close) {
    return null;
  }
  const weekStart = anchor.startOf('week');
  const openAt = weekStart.add(period.open.day, 'day').hour(period.open.hour).minute(period.open.minute).second(0).millisecond(0);
  let closeAt = weekStart.add(period.close.day, 'day').hour(period.close.hour).minute(period.close.minute).second(0).millisecond(0);
  if (closeAt.isBefore(openAt)) {
    closeAt = closeAt.add(1, 'day');
  }
  return closeAt;
}
function collectClosingInstants(hours, tzNow) {
  const seen = new Set();
  for (const anchor of [tzNow.subtract(1, 'day'), tzNow, tzNow.add(1, 'day')]) {
    for (const period of hours.periods) {
      const closeAt = closeInstantForAnchor(anchor, period);
      if (closeAt) {
        seen.add(closeAt.valueOf());
      }
    }
  }
  return [...seen].sort((a, b) => a - b).map(value => (0, dayjs_1.default)(value));
}
function pushUniquePlan(plans, plan) {
  const exists = plans.some(existing => existing.closesAt.getTime() === plan.closesAt.getTime());
  if (!exists) {
    plans.push(plan);
  }
}
function planTimerForClosingInstant(now, closeAt, reason) {
  const warnAt = closeAt.subtract(exports.VENUE_CLOSING_WARNING_MINUTES, 'minute');
  const closesAtDate = closeAt.toDate();
  if (closeAt.isAfter(now)) {
    const warningAt = warnAt.isBefore(now) ? now : warnAt;
    return {
      closesAt: closesAtDate,
      warningAt: warningAt.toDate(),
      checkoutAt: closesAtDate,
      reason
    };
  }
  const catchUpWindowStart = now.subtract(exports.VENUE_CLOSING_CRON_INTERVAL_MINUTES, 'minute');
  if (closeAt.isAfter(catchUpWindowStart) || closeAt.isSame(catchUpWindowStart)) {
    return {
      closesAt: closesAtDate,
      warningAt: now.toDate(),
      checkoutAt: now.add(exports.VENUE_CLOSING_WARNING_MINUTES, 'minute').toDate(),
      reason: 'catch_up'
    };
  }
  return null;
}
function planOpeningHoursTimers(venue, nowUtc) {
  const hours = getEffectiveOpeningHours(venue);
  if (!hasDefinedClosingHours(hours)) {
    return [];
  }
  const tz = resolveVenueTimezone(venue);
  const now = (0, dayjs_1.default)(nowUtc).tz(tz);
  const windowEnd = now.add(exports.VENUE_CLOSING_CRON_INTERVAL_MINUTES, 'minute');
  const windowStart = now.subtract(exports.VENUE_CLOSING_CRON_INTERVAL_MINUTES, 'minute');
  const plans = [];
  for (const closeAt of collectClosingInstants(hours, now)) {
    if (closeAt.isAfter(windowEnd)) {
      continue;
    }
    if (closeAt.isBefore(windowStart) && !closeAt.isSame(windowStart)) {
      continue;
    }
    const reason = closeAt.isAfter(now) ? 'opening_hours' : 'catch_up';
    const plan = planTimerForClosingInstant(now, closeAt, reason);
    if (plan) {
      pushUniquePlan(plans, plan);
    }
  }
  return plans;
}
function planRegional4AmTimer(venue, nowUtc) {
  const hours = getEffectiveOpeningHours(venue);
  if (hasDefinedClosingHours(hours)) {
    return null;
  }
  const tz = resolveVenueTimezone(venue);
  const now = (0, dayjs_1.default)(nowUtc).tz(tz);
  if (now.hour() !== exports.REGIONAL_VENUE_CLOSING_HOUR) {
    return null;
  }
  const closesAt = now.startOf('hour');
  return {
    closesAt: closesAt.toDate(),
    warningAt: now.toDate(),
    checkoutAt: closesAt.add(exports.VENUE_CLOSING_WARNING_MINUTES, 'minute').toDate(),
    reason: 'regional_4am'
  };
}
/** Closing timers to schedule before the next cron tick (~30 minutes). */
function planVenueClosingTimers(venue) {
  let nowUtc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  const plans = [];
  for (const plan of planOpeningHoursTimers(venue, nowUtc)) {
    pushUniquePlan(plans, plan);
  }
  const regional = planRegional4AmTimer(venue, nowUtc);
  if (regional) {
    pushUniquePlan(plans, regional);
  }
  return plans.sort((a, b) => a.warningAt.getTime() - b.warningAt.getTime());
}
//# sourceMappingURL=venue-closing-schedule.js.map